import React from 'react'
import styled from 'styled-components'
import DesktopView from './DesktopView'
import useMediaQuery from 'src/Utils/useMediaQuery'
import SingleRowCard from 'src/Component/SingleRowCard'
import { localize } from 'src/lib/localize'
import ExpandableAdditionalDetailsView from 'src/Home/AdditionalDetail/MobileView/Container'
import { useHistory } from 'react-router-dom'
import { Route } from 'src/Common/Route'

const MainContainer = styled.div``

const SingleRowCardContainer = styled.div`
  margin-top: 8px;
  margin-bottom: 16px;
`

const additionalDetailText = localize('TITLE')('Additional Test Details')

interface Props {
  network_type?: string
  serverHost: string
  location?: string
  ipAddress?: string
  ssid?: string
  serverLocation: string
  showAllCategory?: boolean
  provider?: string
  isExpanded?: boolean
}

const AdditionalDetail = ({
  network_type,
  serverHost,
  location,
  ipAddress,
  ssid,
  serverLocation,
  showAllCategory = false,
  provider,
  isExpanded = false,
}: Props) => {
  const isMobileView = useMediaQuery(['(max-width: 768px)'], [true], false)
  const history = useHistory()

  const navigateToDetails = () => {
    history.push(Route.ADDITIONAL_DETAILS, {
      network_type: network_type,
      serverHost: serverHost,
      user_location: location,
      ipAddress: ipAddress,
      serverLocation: serverLocation,
      provider: provider,
    })
  }

  const showView = () => {
    if (isMobileView) {
      if (isExpanded) {
        return (
          <ExpandableAdditionalDetailsView
            server_host={serverHost}
            location={location}
            client_ip={ipAddress}
            provider_name={provider}
            server_location={serverLocation}
            network_type={network_type}
          />
        )
      } else {
        return (
          <SingleRowCardContainer>
            <SingleRowCard
              title={additionalDetailText}
              onPress={navigateToDetails}
            />
          </SingleRowCardContainer>
        )
      }
    } else {
      return (
        <DesktopView
          network_type={network_type}
          serverHost={serverHost}
          location={location}
          ipAddress={ipAddress}
          ssid={ssid}
          serverLocation={serverLocation}
          showAllCategory={showAllCategory}
          provider={provider}
        />
      )
    }
  }
  return <MainContainer>{showView()}</MainContainer>
}

export default AdditionalDetail
